import { FinanceHubCustomerListItemFieldsFragment } from '@/types';
import { FinanceHubCustomerRow } from '@finance-hub/domain/customers/blocs/types/customer-list';
import { formatCurrency } from '@/utils/money';

const EMPTY_VALUE = '—';

export const transformFinanceHubCustomerListItem = (
  item: FinanceHubCustomerListItemFieldsFragment,
): FinanceHubCustomerRow => ({
  accountIdLabel: item.account_id?.trim() || EMPTY_VALUE,
  addressLabel: item.address ?? null,
  chatId: item.chat_id,
  customerNameLabel: item.customer_name ?? EMPTY_VALUE,
  hasAutopay: item.has_autopay,
  hasContactInfo: item.has_contact_info,
  hasPaymentMethod: item.has_payment_method,
  hasPaymentPlan: item.has_payment_plan,
  hasStatement: item.has_statement,
  invoiceCount: item.invoice_count,
  outstandingInMicros: item.outstanding_balance_in_micros,
  outstandingLabel: formatCurrency(
    item.outstanding_balance_in_micros,
    item.currency_code,
    { currencyDisplay: 'narrowSymbol' },
  ),
});
